import React, { Component } from "react";
import { reduxForm } from "redux-form";
import {
  TabContent,
  TabPane,
  Nav,
  Button,
  Row,
  Col,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import "./style.css";
import Api from "../../services/api";
import { FaCheckCircle, FaExclamationCircle, FaEye } from "react-icons/fa";
import { connect } from "react-redux";
import FormPrint from "../../components/FormPrint";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as ministryModalAction from "../../actions/ministryAction";
import MainLoader from "../../components/MainLoader";
import { FaCloudUploadAlt } from "react-icons/fa";
import Comments from "../../components/modals/Comments";
import ModalComp from "../../components/modals/ModalComp";
import AllComments from "../SelfAssessmentForm/AllComments";

class MinistryLevelEvaluation extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this._getCategories = this._getCategories.bind(this);
    this._setAnwerDocs = this._setAnwerDocs.bind(this);
    this._sendRemarks = this._sendRemarks.bind(this);
    this._sendRemarks = _.debounce(this._sendRemarks, 1500);
    this._handleTextAreaChange = this._handleTextAreaChange.bind(this);
    this.state = {
      activeTab: 1,
      activeTabIndex: 0,
      activeCategoryIndex: 0,
      categories: [],
      isLoading: true,
      answers: null,
      hasCompleted: {},
      isCompleted: {},
      answerDocs: {},
      print: false,
      total_comment_count: "",
      remarksTicked: [],
      autoFocus: false,
      palika_name: "",
      cao_approved: 0,
      current_stage: null,
    };
  }

  componentDidMount() {
    this._getCategories();
    if (sessionStorage.getItem("tab")) {
      //   this.setState(JSON.parse(sessionStorage.getItem("tab")));
      this.setState(JSON.parse(sessionStorage.getItem("tab")));
    }
  }

  _setAnwerDocs(documentId, url) {
    const { user } = this.props;
    let { answerDocs } = this.state;
    if (user.hasSubmitted) return;
    answerDocs[documentId] = answerDocs[documentId]
      ? answerDocs[documentId]
      : {};
    answerDocs[documentId].url = url;
    this.setState({ answerDocs });
  }

  toggle(activeTabIndex, activeTab) {
    if (this.state.activeTab !== activeTab) {
      this.setState({
        activeTab,
        activeTabIndex,
      });
    }
  }

  async _getCategories() {
    const { user, fiscal_year_id } = this.props;
    try {
      // let response = await Api.getMinistryQuestions(
      //   fiscal_year_id,
      //   sessionStorage.getItem("provinceId"),
      //   user.ministry_id
      // );
      let response = await Api.getQuestions(
        user.fiscal_year_id,
        sessionStorage.getItem("provinceId"),
        JSON.parse(localStorage.getItem("user")).user.ocmcm_id ||
        sessionStorage.getItem("provinceId")
      );
      let categories = response.response.questions;
      this.setState({
        current_stage: response.response.status,
      });
      categories = this._setIsCompletedCategory(categories);
      if (user.role === "OCMCM Data Entry") {
        categories = this._setDisabledCategory(categories);
      }
      this.setState({
        categories,
        activeTab: categories[0].subCategories[0].id,
        firstTab: categories[0].subCategories[0].id,
        isLoading: false,
        palika_name: response.response.palika_name,
        total_comment_count: response.response.total_comment_count,
        current_stage: response.response.status,
      });
    } catch (e) {
      toast.error(e, {
        position: toast.POSITION.TOP_CENTER,
      });
      this.setState({ isLoading: false });
    }
  }

  _setDisabledCategory = (categories) => {
    const { user } = this.props;
    let role = user.role_id;
    categories.map((category) => {
      if (
        (this.state.current_stage === 0 || this.state.current_stage === 1) &&
        role === 8
      ) {
        category.isDisabled = false;
      } else {
        category.isDisabled = true;
      }
    });
    return categories;
  };

  _getDisabled = () => {
    const { user } = this.props;
    let disabled = true;
    if (user.role_id === 7 && this.state.current_stage === 3) {
      disabled = false;
    }
    return disabled;
  };
  _updateForm = async (
    activeCategory,
    subCategory,
    question,
    option,
    subCatIndex,
    qnIndex
  ) => {
    const { user } = this.props;
    let { categories, activeCategoryIndex } = this.state;
    this.setState({ isLoading: true });

    try {
      // let response = await Api.sendMinistryResponse({
      //   fiscal_year_id: user.fiscal_year_id,
      //   question_id: question.id,
      //   option_id: option.id,
      //   score: option.marks,
      //   ministry_id: user.ministry_id,
      //   province: user.province_id
      //     ? user.province_id
      //     : sessionStorage.getItem("provinceId"),
      // });
      let response = await Api.sendResponse({
        fiscal_year_id: user.fiscal_year_id,
        question_id: question.id,
        option_id: option.id,
        score: option.marks,

        ocmcm_id: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).user.ocmcm_id
          : sessionStorage.getItem("provinceId"),
        province_id: sessionStorage.getItem("provinceId"),
      });
      if (response.code === 200 || response.code === 204) {
        let updatedCategories = categories;
        updatedCategories[activeCategoryIndex].subCategories[
          subCatIndex
        ].questions[qnIndex].selected_option = option.id;
        updatedCategories = this._setIsCompletedCategory();
        this.setState({ categories: updatedCategories });
      } else {
        toast.error(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (e) {
      toast.error(e, {
        position: toast.POSITION.TOP_CENTER,
      });
    }

    this.setState({ isLoading: false });
    return;
  };

  _onNextClick = () => {
    window.scrollTo(0, 0);
    const {
      activeTab,
      activeCategoryIndex,
      activeTabIndex,
      categories,
    } = this.state;
    let newActiveTab, newactiveCategoryIndex, newActiveTabIndex, newState;

    if (
      activeTabIndex ===
      categories[activeCategoryIndex].subCategories.length - 1
    ) {
      newActiveTabIndex = 0;
      newactiveCategoryIndex = activeCategoryIndex + 1;
      newActiveTab = categories[
        newactiveCategoryIndex
      ].subCategories[0].id.toString();
      newState = {
        activeCategoryIndex: newactiveCategoryIndex,
        activeTabIndex: newActiveTabIndex,
        activeTab: parseInt(newActiveTab),
      };
    } else {
      newActiveTabIndex = parseInt(activeTabIndex) + 1;
      newActiveTab =
        categories[activeCategoryIndex] &&
        categories[activeCategoryIndex].subCategories[newActiveTabIndex] &&
        categories[activeCategoryIndex].subCategories[newActiveTabIndex].id;
      newState = {
        activeTab: parseInt(newActiveTab),
        activeTabIndex: newActiveTabIndex,
      };
    }
    this.setState({ ...newState, autoFocus: false });
  };

  _onPrevClick = () => {
    window.scrollTo(0, 0);
    const {
      activeTab,
      activeCategoryIndex,
      activeTabIndex,
      categories,
    } = this.state;

    let newActiveTab, newactiveCategoryIndex, newActiveTabIndex, newState;
    if (activeTabIndex === 0) {
      newActiveTabIndex = 0;
      newactiveCategoryIndex = activeCategoryIndex - 1;
      newActiveTab = categories[newactiveCategoryIndex].subCategories[
        categories[newactiveCategoryIndex].subCategories.length - 1
      ].id.toString();

      newState = {
        activeCategoryIndex: newactiveCategoryIndex,
        activeTab: parseInt(newActiveTab),
        activeTabIndex: newActiveTabIndex,
      };
      this.setState({ ...newState, autoFocus: false });

      return;
    } else {
      newState = newActiveTab = parseInt(activeTab) - 1;
      this.setState({ activeTab: parseInt(newActiveTab) });
    }
    // console.log("newStateII", newState);
    this.setState({ ...newState, autoFocus: false });
  };

  _onCategoryClick(activeCategoryIndex) {
    window.scrollTo(0, 0);
    const { categories } = this.state;
    let activeTabIndex = 0;
    this.setState({
      activeCategoryIndex,
      activeTab:
        categories[activeCategoryIndex].subCategories[activeTabIndex].id,
      activeTabIndex,
      autoFocus: false,
    });
  }

  _handleRemarksCheck = (e, question) => {
    let updatedRemarksTicked = [...this.state.remarksTicked];
    if (e.target.checked) {
      updatedRemarksTicked.push(question.id);
    } else {
      updatedRemarksTicked = updatedRemarksTicked.filter(
        (tickedQuestionId, i) => tickedQuestionId !== question.id
      );
    }
    this.setState({ remarksTicked: updatedRemarksTicked });
  };

  // _handleTextAreaChange = async (
  //   e,
  //   question,
  //   activeCategoryIndex,
  //   subCatIndex,
  //   qnIndex
  // ) => {
  //   let { categories } = this.state;
  //   let activeCategory = categories[activeCategoryIndex];
  //   activeCategory.subCategories[subCatIndex].questions[qnIndex].remarks =
  //     e.target.value;
  //   question.remarks = e.target.value;
  //   this.setState({ categories: categories });
  // };
  _handleTextAreaChange = async (
    e,
    question,
    activeCategoryIndex,
    subCatIndex,
    qnIndex,
    score,
    stage_id
  ) => {
    let { categories } = this.state;
    let activeCategory = categories[activeCategoryIndex];

    const { user } = this.props;
    activeCategory.subCategories[subCatIndex].questions[qnIndex].remarks =
      e.target.value;

    question.remarks = e.target.value;
    this.setState({ categories: categories });
    this._sendRemarks(question);
  };
  async _sendRemarks(question) {
    const { user } = this.props;
    // let response = await Api.sendMinistryResponse({
    //   fiscal_year_id: user.fiscal_year_id,
    //   question_id: question.id,
    //   remarks: question.remarks,
    //   ministry_id: user.ministry_id,
    //   province: user.province_id
    //     ? user.province_id
    //     : sessionStorage.getItem("provinceId"),
    // });
    // let response = await Api.sendResponse({
    //   fiscal_year_id: user.fiscal_year_id,
    //   question_id: question.id,
    //   remarks: question.remarks,
    //   ministry_id: user.ministry_id,
    //   score: question.marks,
    //   stage_id: this.state.current_stage,
    //   province: sessionStorage.getItem("provinceId"),
    //   // option_id: question.id,
    // });
    let response = await Api.sendResponse({
      fiscal_year_id: user.fiscal_year_id,
      question_id: question.id,
      remarks: question.remarks,
      // stage_id: this.state.current_stage,
      score: question.marks,

      ocmcm_id: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).user.ocmcm_id
        : sessionStorage.getItem("provinceId"),
      province_id: sessionStorage.getItem("provinceId"),
    });
    if (response.code !== 200) {
      toast.error(response.message, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
  // {console.log("first", this.state.current_stage)}
  _renderDocumentListFromOption(question) {
    let documentList = [];
    let selectedOption = question.selected_option;
    if (selectedOption) {
      question.options.map((option) => {
        if (option.id === selectedOption) {
          if (option.documents.length === 0) {
            documentList.push(
              <p className="document-name document-empty" key={"no-doc"}>
                &bull; कुनैपनि प्रमाणीकरणको आधारहरु नचाहिने{" "}
                <FaCheckCircle className="check-circle-doc" color="#28a745" />
              </p>
            );
          }
          option.documents.map((document) => {
            const { user } = this.props;
            let singleDoc;
            if (document.path) {
              singleDoc = (
                <React.Fragment key={document.id}>
                  {this.state.current_stage === 4 ? (
                    <div className="d-flex gap-1">
                      <p
                        // onClick={() => this._openDocumentModal(document)}
                        className="document-name"
                      >
                        &bull; {document.name}
                        {/* <FaCheckCircle
                          className="check-circle-doc"
                          color="#28a745"
                        /> */}
                      </p>
                      <a href={document.path} target="_blank">
                        <FaEye className="eye_icon" color="#28a745" />
                      </a>
                    </div>
                  ) : (
                    <div className="d-flex">
                      <a className="d-flex align-items-baseline">
                        <p
                          onClick={() => this._openDocumentModal(document)}
                          className="document-name"
                        >
                          &bull; {document.name}
                          <FaCheckCircle
                            className="check-circle-doc"
                            color="#28a745"
                          />
                        </p>
                      </a>
                      <a href={document.path} target="_blank">
                        <FaEye className="eye_icon" color="#28a745" />
                      </a>
                    </div>
                  )}
                </React.Fragment>
              );
            } else {
              singleDoc = (
                <a
                  onClick={() => this._openDocumentModal(document)}
                  key={document.id}
                >
                  <p className="document-name">
                    &bull; {document.name}
                    {/* <FaExclamationCircle
                      className="check-circle-doc"
                      color="#e12a2a"
                    /> */}
                    <FaCloudUploadAlt
                      className="check-circle-doc"
                      color="#2572bc"
                    />
                  </p>
                </a>
              );
            }
            documentList.push(singleDoc);
            //if path==="" show exclaim else show tick and link to path.
          });
        }
      });
    }
    return documentList;
  }

  _onDocumentRemoved = (removedDoc) => {
    let { categories } = this.state;
    categories.map((question) => {
      question.subCategories &&
        question.subCategories.length > 0 &&
        question.subCategories.map((subCat) => {
          subCat.questions &&
            subCat.questions.length > 0 &&
            subCat.questions.map((question) => {
              question.options &&
                question.options.length > 0 &&
                question.options.map((option) => {
                  option.documents &&
                    option.documents.length > 0 &&
                    option.documents.map((document) => {
                      if (document.id === removedDoc.id) {
                        document.path = "";
                      }
                    });
                });
            });
        });
    });
    categories = this._setIsCompletedCategory(categories);
    this.setState({ categories });

    // console.log("state", this.state);
    //update cateegory obkect
  };

  _onDocumentUploaded = (uploadedDoc, response) => {
    let { categories } = this.state;
    categories.map((question) => {
      question.subCategories &&
        question.subCategories.length > 0 &&
        question.subCategories.map((subCat) => {
          subCat.questions &&
            subCat.questions.length > 0 &&
            subCat.questions.map((question) => {
              question.options &&
                question.options.length > 0 &&
                question.options.map((option) => {
                  option.documents &&
                    option.documents.length > 0 &&
                    option.documents.map((document) => {
                      if (document.id === uploadedDoc.id) {
                        document.path = response.response.path;
                      }
                    });
                });
            });
        });
    });
    categories = this._setIsCompletedCategory(categories);
    this.setState({ categories });

    //update cateegory obkect
  };

  _openDocumentModal = (document) => {
    const { onDocumentsShow } = this.props;
    onDocumentsShow({
      clickedDocument: document,
      onDocumentRemoved: this._onDocumentRemoved,
      onDocumentUploaded: this._onDocumentUploaded,
    });
  };

  _setIsCompletedCategory = (categoriesList) => {
    let { categories } = this.state;
    let categoryIsCompletedList =
      categories.length === 0 ? categoriesList : categories;
    categoryIsCompletedList.map((category) => {
      let isCatCompleted = true;
      category.subCategories &&
        category.subCategories.length > 0 &&
        category.subCategories.map((subCat) => {
          let isSubCatCompleted = true;
          subCat.questions &&
            subCat.questions.length > 0 &&
            subCat.questions.map((question) => {
              let isQuestionCompleted = true;
              if (!question.selected_option) {
                isCatCompleted = false;
                isSubCatCompleted = false;
                isQuestionCompleted = false;
              } else {
                const selectedOptionObject = question.options.filter(
                  (option) => {
                    return option.id === question.selected_option;
                  }
                );
                selectedOptionObject[0].documents.map((document) => {
                  if (!document.path) {
                    isCatCompleted = false;
                    isSubCatCompleted = false;
                    isQuestionCompleted = false;
                  }
                });
              }
              question.isCompleted = isQuestionCompleted;
            });
          subCat.isCompleted = isSubCatCompleted;
        });
      category.isCompleted = isCatCompleted;
    });
    return categoryIsCompletedList;
  };

  _checkAllAnsCompleted = () => {
    let { categories } = this.state;
    let isCompleted = true;
    categories.map((category) => {
      if (!category.isCompleted) {
        isCompleted = false;
      }
    });
    return isCompleted;
  };

  // let ocmcm_id: localStorage.getItem("user")
  // ? JSON.parse(localStorage.getItem("user")).user.ocmcm_id
  // : sessionStorage.getItem("provinceId");

  render() {
    const { user } = this.props;
    let {
      categories,
      activeCategoryIndex,
      isLoading,
      activeTab,
      firstTab,
      activeTabIndex,
      answerDocs,
      remarksTicked,
    } = this.state;
    let activeCategory = categories[activeCategoryIndex];
    let disabled = this._getDisabled();
    console.log("state check", this.state);

    console.log(
      "total_comment_count and OCMCM_id",
      this.subCategory,
      localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).user.ocmcm_id
        : sessionStorage.getItem("provinceId")
    );

    //   let ocmcm_id: localStorage.getItem("user")
    //   ? JSON.parse(localStorage.getItem("user")).user.ocmcm_id
    //   : sessionStorage.getItem("provinceId"),
    // province_id: sessionStorage.getItem("provinceId"),
    console.log("first current stage", this.state.current_stage);
    return (
      <MainLoader active={isLoading}>
        {categories.length > 0 && (
          <section className="assessment-form">
            <div className="header mb-2">
              <h1 className="heading">{this.state.palika_name}</h1>{" "}
            </div>
            <Row>
              <Col sm="3">
                <Nav
                  className={"sticky_nav"}
                  vertical
                  style={{ width: "100%" }}
                >
                  <div className="cat-heading-wrapper">
                    <h3 className="cat-heading">
                      स्व-मूल्याङ्कन विषयक्षेत्रहरु
                    </h3>
                  </div>
                  {categories &&
                    categories.map((category, catIndex) => {
                      const isImage =
                        category.image.match(/\.(jpeg|jpg|gif|png)$/) !== null;
                      return (
                        <div key={category.id}>
                          <div
                            className={`${activeCategoryIndex === catIndex
                              ? "nav-link-purple-borde px-2"
                              : "nav-link-ordinary px-2"
                              }`}
                            onClick={() => this._onCategoryClick(catIndex)}
                          >
                            <div>
                              <img
                                src={
                                  isImage
                                    ? category.image
                                    : require(`../../assets/images/${catIndex +
                                      1}.svg`)
                                }
                                className="cat-icon"
                                alt="cat-icon"
                              />
                              <span>{category.name}</span>
                            </div>

                            {category.isCompleted ? (
                              <FaCheckCircle
                                className="check-circle mx-2"
                                color="#28a745"
                              />
                            ) : (
                              <FaExclamationCircle
                                className="check-circle mx-2"
                                color="#e12a2a"
                              />
                            )}
                            {activeCategoryIndex === catIndex && (
                              <div className="arrow-righ" />
                            )}
                          </div>
                        </div>
                      );
                    })}
                </Nav>
              </Col>
              {activeCategory && activeCategory.subCategories && (
                <Col sm="9">
                  <div className="d-flex justify-content-end">
                    <AllComments user={user} count={0} />
                  </div>
                  <div className="header-content">
                    <h3 className="subcat-header">{activeCategory.name}</h3>
                  </div>
                  {/* <Nav tabs style={{ width: "100%" }}>
                    {activeCategory &&
                      activeCategory.subCategories &&
                      activeCategory.subCategories.map(
                        (subCategory, sCatIndex) => {
                          return (
                            <NavItem key={subCategory.id}>
                              <NavLink
                                onClick={() => {
                                  this.toggle(sCatIndex, subCategory.id);
                                }}
                                className={
                                  activeTab === subCategory.id ? "active" : ""
                                }
                              >
                                {subCategory.name}{" "}
                                {subCategory.isCompleted ? (
                                  <FaCheckCircle color="#28a745" />
                                ) : (
                                  <FaExclamationCircle
                                    className="check-circle-doc"
                                    color="#e12a2a"
                                  />
                                )}
                              </NavLink>
                            </NavItem>
                          );
                        }
                      )}
                  </Nav> */}
                  <TabContent activeTab={this.state.activeTab}>
                    {activeCategory &&
                      activeCategory.subCategories.map(
                        (subCategory, subCatIndex) => {
                          if (user.role_id === 8) {
                            disabled = !!activeCategory.isDisabled;
                          }
                          return (
                            <TabPane
                              tabId={subCategory.id}
                              key={subCategory.id}
                            >
                              <Row>
                                <Col sm="12">
                                  {/* <h4 className="subcat-header">
                                    {changeIndexToNepali(activeCategory.id)}.
                                    {changeIndexToNepali(subCatIndex + 1)}{" "}
                                    {subCategory.name}
                                  </h4> */}
                                  {subCategory &&
                                    subCategory.questions &&
                                    subCategory.questions.length > 0 &&
                                    subCategory.questions.map(
                                      (question, qnIndex) => {
                                        let selectedOption =
                                          question.selected_option;
                                        return (
                                          <FormGroup
                                            tag="fieldset"
                                            key={question.id}
                                          >
                                            <Row>
                                              <Col sm="12">
                                                <legend className="form-qn">
                                                  {question.question}
                                                </legend>
                                                {question.updated_by && (
                                                  <span className="updated-by">
                                                    <b>{question.updated_by}</b>
                                                    द्वारा{" "}
                                                    <b>
                                                      {new Date(
                                                        question.updated_at
                                                      ).toLocaleDateString(
                                                        "ne-NP",
                                                        {
                                                          day: "numeric",
                                                          month: "short",
                                                          year: "numeric",
                                                        }
                                                      )}
                                                    </b>
                                                    मा अद्यावधिक गरिएको
                                                  </span>
                                                )}
                                                <div>
                                                  {question.options &&
                                                    question.options.map(
                                                      (option, opIndex) => {
                                                        let checked =
                                                          selectedOption &&
                                                            selectedOption ===
                                                            option.id
                                                            ? true
                                                            : false;
                                                        return (
                                                          <FormGroup
                                                            check
                                                            key={option.id}
                                                            className={"mr-3"}
                                                          >
                                                            <Label check>
                                                              <Input
                                                                disabled={
                                                                  disabled
                                                                }
                                                                type="radio"
                                                                name={`radio-${question.id}`}
                                                                checked={
                                                                  checked
                                                                }
                                                                onChange={() => {
                                                                  this._updateForm(
                                                                    activeCategory,
                                                                    subCategory,
                                                                    question,
                                                                    option,
                                                                    subCatIndex,
                                                                    qnIndex
                                                                  );
                                                                }}
                                                              />
                                                              {option.name}
                                                            </Label>
                                                          </FormGroup>
                                                        );
                                                      }
                                                    )}
                                                </div>
                                                <div className="proof">
                                                  <legend>
                                                    प्रमाणीकरणको आधार:
                                                  </legend>
                                                  <Row>
                                                    <Col sm="12">
                                                      {this._renderDocumentListFromOption(
                                                        question
                                                      )}
                                                      {/* <p className="document-name">&bull; {question.selected_option.name}</p> */}
                                                    </Col>
                                                    <Col sm="6">
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          gap: "10px",
                                                        }}
                                                      >
                                                        <ModalComp
                                                          comment={true}
                                                          stage_id={
                                                            question.comment_count
                                                          }
                                                          ocmcm_id={
                                                            localStorage.getItem(
                                                              "user"
                                                            )
                                                              ? JSON.parse(
                                                                localStorage.getItem(
                                                                  "user"
                                                                )
                                                              ).user.ocmcm_id
                                                              : sessionStorage.getItem(
                                                                "provinceId"
                                                              )
                                                          }
                                                          token={
                                                            JSON.parse(
                                                              localStorage.getItem(
                                                                "user"
                                                              )
                                                            ).token
                                                          }
                                                          question_id={
                                                            question.id
                                                          }
                                                          fiscalYear={
                                                            sessionStorage.getItem(
                                                              "step_data"
                                                            )
                                                              ? JSON.parse(
                                                                sessionStorage.getItem(
                                                                  "step_data"
                                                                )
                                                              ).fiscal_year_id
                                                              : localStorage.getItem(
                                                                "fiscalYear"
                                                              )
                                                          }
                                                          state={{
                                                            activeTab: this
                                                              .state.activeTab,
                                                            activeCategoryIndex: this
                                                              .state
                                                              .activeCategoryIndex,
                                                            activeTabIndex: this
                                                              .state
                                                              .activeTabIndex,
                                                          }}
                                                        />
                                                        {/* <div
                                                          style={{
                                                            backgroundColor:
                                                              "#2572bc",
                                                            color: "white",
                                                            borderRadius: "50%",
                                                            padding: "6px 8px",
                                                            fontSize: "12px",
                                                            fontWeight: "500",
                                                          }}
                                                        >
                                                          {
                                                            question.comment_count
                                                          }
                                                        </div> */}
                                                      </div>
                                                      <div className="remarks-wrapper">
                                                        <label>
                                                          <input
                                                            type="checkbox"
                                                            onChange={(e) => {
                                                              return this._handleRemarksCheck(
                                                                e,
                                                                question
                                                              );
                                                            }}
                                                            checked={
                                                              !!question.remark ||
                                                              remarksTicked.includes(
                                                                question.id
                                                              )
                                                            }
                                                          />
                                                          &nbsp;&nbsp;&nbsp;कैफियत{" "}
                                                          <br />
                                                        </label>
                                                        {(question.remark ||
                                                          remarksTicked.includes(
                                                            question.id
                                                          )) && (
                                                            <textarea
                                                              name="textarea"
                                                              value={
                                                                question.remark
                                                              }
                                                              onChange={(e) =>
                                                                this._handleTextAreaChange(
                                                                  e,
                                                                  question,
                                                                  activeCategoryIndex,
                                                                  subCatIndex,
                                                                  qnIndex
                                                                )
                                                              }
                                                            ></textarea>
                                                          )}
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </div>
                                              </Col>
                                            </Row>
                                          </FormGroup>
                                        );
                                      }
                                    )}

                                  {activeCategoryIndex === 0 &&
                                    activeTab === firstTab ? (
                                    ""
                                  ) : (
                                    <Button
                                      className="previous"
                                      onClick={this._onPrevClick}
                                    >
                                      <p>अघिल्लो</p>
                                    </Button>
                                  )}
                                  <div className="right-button">
                                    {activeCategoryIndex ===
                                      categories.length - 1 &&
                                      activeTabIndex ===
                                      categories[activeCategoryIndex]
                                        .subCategories.length -
                                      1 ? (
                                      <Button
                                        className="next"
                                        onClick={() =>
                                          this.props.history.goBack()
                                        }
                                      >
                                        <p>समाप्त</p>
                                      </Button>
                                    ) : (
                                      <Button
                                        className="next"
                                        onClick={this._onNextClick}
                                      >
                                        <p>अर्को</p>
                                      </Button>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </TabPane>
                          );
                        }
                      )}
                  </TabContent>
                </Col>
              )}
            </Row>
            <FormPrint
              categories={categories}
              // answers={answers}
              answerDocs={answerDocs}
              remarksTicked={remarksTicked}
              ref={(el) => (this.componentRef = el)}
            />
            {/* } */}
            <ToastContainer />
            {/* <UserFeedback /> */}
          </section>
        )}
      </MainLoader>
    );
  }
}

MinistryLevelEvaluation = reduxForm({
  // a unique name for the form
  form: "MinistryLevelEvaluation",
})(MinistryLevelEvaluation);

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
  fiscal_year_id: auth.login.fiscal_year_id,
});

const mapDispatchToProps = (dispatch) => ({
  onDocumentsShow: (modalProps) => {
    dispatch(
      ministryModalAction.processModal(
        ministryModalAction.MINISTRYSHOW_MODAL,
        ministryModalAction.ModalTypes.MINISTRYSHOW_DOCUMENT,
        modalProps
      )
    );
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MinistryLevelEvaluation);
